import React from 'react'
import styled from '@emotion/styled'

export const SNSLink = ({ image, linkTo, alt }) => {
  return (
    <OuterLink href={linkTo} target="_blank">
      <Logo src={image} alt={alt} />
    </OuterLink>
  )
}

const Logo = styled.img`
  height: 100%;
`

const OuterLink = styled.a`
  height: 100%;
  margin: 0 10px;
`
